import { render, staticRenderFns } from "./HandbookTable.vue?vue&type=template&id=55bdb1b6&scoped=true&"
import script from "./HandbookTable.vue?vue&type=script&lang=js&"
export * from "./HandbookTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bdb1b6",
  null
  
)

export default component.exports